
/**
 * 共通設定の呼び出し
 */

const commonScripts = () => {
	// ページスクロール
	let showFlag = false;
	const pagetop = $('#go-top');
    pagetop.hide();
	//スクロールが100に達したらボタン表示
	$(window).scroll(function () {
		if ($(this).scrollTop() > 100) {
			pagetop.fadeIn();
		} else {
			 pagetop.fadeOut();
		}
	});


	let adminBar_height = $('#wpadminbar').height();
	if(!adminBar_height){
		adminBar_height = 0;
	}
	$('.page-scroll a').on('click', function(event) {
		const anchor = $(this);
		const diff = $('.sticky-header').innerHeight();
		$('html, body').stop().animate({
			scrollTop: $(anchor.attr('href')).offset().top - adminBar_height - diff
		}, 1500, 'easeInOutExpo');
		event.preventDefault();
	});

	// 年表示
	const time = new Date();
	const year = time.getFullYear();
	$('span.time').html(year);

}

export default commonScripts;
